import { GENSET_SUB_KATEGORI_CONSTANT } from './GENSET_SUB_KATEGORI_CONSTANT';

const initialState = {
  status_GET: 'IDLE',
  message: '',
  list: [],
  properties: {},
};

export function GENSET_SUB_KATEGORI_REDUCER(state = initialState, action) {
  let returnData = state;
  Object.values(GENSET_SUB_KATEGORI_CONSTANT).map((ctx) => {
    if (action.type === GENSET_SUB_KATEGORI_CONSTANT.RESET_STATUS) {
      returnData = {
        ...returnData,
        status_GET: 'IDLE',
        status_POST: 'IDLE',
        status_PUT: 'IDLE',
        status_DELETE: 'IDLE',
        message: '',
      };
    } else if (action.type === GENSET_SUB_KATEGORI_CONSTANT.RESET_ALL) {
      returnData = {
        status_GET: 'IDLE',
        status_POST: 'IDLE',
        status_PUT: 'IDLE',
        status_DELETE: 'IDLE',
        message: '',
        data: {},
      };
    } else if (ctx === action.type && !ctx.includes('[NO_STATE_UPDATE]')) {
      returnData = { ...returnData, ...action.payload };
    }
    return null;
  });

  return returnData;
}
